var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStudentLoanIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9095_22573)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF6DE8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.9171 21.2484C18.8567 21.2484 18.7972 21.2361 18.7412 21.2116L15.095 19.6077C14.9366 19.5377 14.8334 19.3811 14.8334 19.2069C14.8334 19.0328 14.9358 18.8762 15.095 18.8062L18.7412 17.2023C18.8532 17.1533 18.9818 17.1533 19.0938 17.2023L22.7401 18.8062C22.8984 18.8762 23.0008 19.0328 23.0008 19.2069C23.0008 19.3811 22.8984 19.5377 22.7392 19.6077L19.093 21.2116C19.0378 21.2361 18.9775 21.2484 18.9171 21.2484Z",
    fill: "#FFE8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.4458 22.0121C19.2761 22.0865 19.0993 22.1232 18.9173 22.1232C18.7353 22.1232 18.5586 22.0865 18.3906 22.013L16 20.9612V21.3628C16 21.7189 16.1864 22.0532 16.4848 22.2352C17.3257 22.7445 18.121 23 18.9164 23C19.7118 23 20.5072 22.7445 21.3481 22.2352C21.6474 22.0532 21.8329 21.7189 21.8329 21.3628V20.9612L19.4458 22.0121Z",
    fill: "#FFE8FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.2498 14.8338C12.6415 14.8338 11.3334 13.5256 11.3334 11.9173C11.3334 10.309 12.6415 9 14.2498 9C15.8581 9 17.1663 10.3082 17.1663 11.9164C17.1663 13.5247 15.8581 14.8338 14.2498 14.8338Z",
    fill: "#FFE8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.6665 19.2089C13.6665 18.5728 14.0401 17.9953 14.6229 17.7389L17.9943 16.2514C17.6566 16.0877 17.2777 16.0002 16.8752 16.0002H11.6251C10.1787 16.0002 9 17.1789 9 18.6253V20.959C9 21.1217 9.12863 21.2504 9.29138 21.2504H14.8329V20.7665L14.6229 20.6729C14.0401 20.4165 13.6665 19.839 13.6665 19.2089Z",
    fill: "#FFE8FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9095_22573",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9095_22573"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStudentLoanIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/student_loan_icon.0ac8fe7418771c4ca83e0cbdb313a86c.svg";